import { prodapiAxiosClient } from "../api/prodApiClient";

const getShipment = (shipmentCode) => {
    return prodapiAxiosClient
    .get(`/api/v1/shipment/${shipmentCode}`)
}

const getShipmentsByStatus = (status) => {
    return prodapiAxiosClient
    .get(`/api/v1/shipment/status/${status}`)
}

const createShipment = (shipment) => {
    return prodapiAxiosClient
    .post("/api/v1/shipment", shipment)
}

const updateShipment = (shipmentCode, data) => {
    return prodapiAxiosClient
    .put(`/api/v1/shipment/${shipmentCode}`, data)
}

const updateShipmentStatus = (shipmentCode, status) => {
    return prodapiAxiosClient
    .put(`/api/v1/shipment/${shipmentCode}/status`, { status })
}

const sendShipmentToNetsuite = (shipmentCode) => {
    return prodapiAxiosClient
    .post(`/api/v1/shipment/${shipmentCode}/sendToNetsuite`)
}

const shipmentApi = { createShipment, getShipment, getShipmentsByStatus, updateShipment, updateShipmentStatus, sendShipmentToNetsuite }
export default shipmentApi;